<template>
	<div
		class="product-card"
		:class="{
			'product-card_market': isMarket,
		}"
		@click="goToProduct(item)"
	>
		<div
			v-if="item?.id === chosenItem"
			class="product-card__added-inscription _md"
		>
			{{ $t(`Added`) }}
		</div>
		<div
			class="product-card__bg _ibg-contain"
			:class="{ 'product-card__bg_market': isMarket }"
		>
			<img src="@/assets/img/bg/card-bg.png" />
		</div>
		<div class="product-card__top">
			<div
				class="product-card__image _ibg-contain"
				:class="{ 'product-card__image_market': isMarket }"
			>
				<img :src="getImageUrl(item)" :alt="getTitle(item)" />
			</div>
			<div
				class="product-card__title _md"
				:class="{ 'product-card__title_market': isMarket }"
			>
				{{ getTitle(item) }}
			</div>
		</div>
		<div
			class="product-card__price"
			:class="{ 'product-card__price_market': isMarket }"
		>
			<div v-if="hasDiscount" class="product-card__old">
				<div class="product-card__old-number">{{ getOldPrice(item) }}</div>
				<div class="product-card__old-icon _svg-icon">
					<svg
						width="19"
						height="19"
						viewBox="0 0 19 19"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
							fill="#FFE180"
						/>
						<path
							d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
							fill="#FFB030"
						/>
						<path
							d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
							fill="#FFC926"
						/>
						<path
							d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
							fill="white"
						/>
						<path
							d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
							fill="white"
						/>
						<path
							d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
							fill="white"
						/>
						<path
							d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
							fill="white"
						/>
						<path
							d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
							fill="white"
						/>
						<path
							d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
							fill="white"
						/>
						<path
							d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
							fill="white"
						/>
						<path
							d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
							fill="white"
						/>
						<path
							d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
							fill="white"
						/>
						<path
							d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
							fill="white"
						/>
						<path
							d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
							fill="white"
						/>
						<path
							d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
							fill="white"
						/>
						<path
							d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
							fill="white"
						/>
						<path
							d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
							fill="white"
						/>
						<path
							d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
							fill="white"
						/>
						<path
							d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
							fill="white"
						/>
						<path
							d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
							fill="white"
						/>
						<path
							d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
							fill="white"
						/>
						<path
							d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
							fill="white"
						/>
						<path
							d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
							fill="white"
						/>
						<path
							d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
							fill="white"
						/>
						<path
							d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
							fill="white"
						/>
						<path
							d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
							fill="white"
						/>
						<path
							d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
							fill="white"
						/>
						<path
							d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
							fill="white"
						/>
						<path
							d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
							fill="white"
						/>
						<path
							d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
							fill="white"
						/>
						<path
							d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
							fill="white"
						/>
						<path
							d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
							fill="white"
						/>
						<path
							d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
							fill="white"
						/>
					</svg>
				</div>
			</div>
			<div class="product-card__new">
				<div class="product-card__new-number _md">
					{{ item.internal_price ? item.internal_price : getBasePrice(item) }}
				</div>
				<div class="product-card__new-icon _svg-icon">
					<svg
						width="19"
						height="19"
						viewBox="0 0 19 19"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
							fill="#FFE180"
						/>
						<path
							d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
							fill="#FFB030"
						/>
						<path
							d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
							fill="#FFC926"
						/>
						<path
							d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
							fill="white"
						/>
						<path
							d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
							fill="white"
						/>
						<path
							d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
							fill="white"
						/>
						<path
							d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
							fill="white"
						/>
						<path
							d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
							fill="white"
						/>
						<path
							d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
							fill="white"
						/>
						<path
							d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
							fill="white"
						/>
						<path
							d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
							fill="white"
						/>
						<path
							d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
							fill="white"
						/>
						<path
							d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
							fill="white"
						/>
						<path
							d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
							fill="white"
						/>
						<path
							d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
							fill="white"
						/>
						<path
							d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
							fill="white"
						/>
						<path
							d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
							fill="white"
						/>
						<path
							d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
							fill="white"
						/>
						<path
							d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
							fill="white"
						/>
						<path
							d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
							fill="white"
						/>
						<path
							d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
							fill="white"
						/>
						<path
							d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
							fill="white"
						/>
						<path
							d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
							fill="white"
						/>
						<path
							d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
							fill="white"
						/>
						<path
							d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
							fill="white"
						/>
						<path
							d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
							fill="white"
						/>
						<path
							d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
							fill="white"
						/>
						<path
							d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
							fill="white"
						/>
						<path
							d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
							fill="white"
						/>
						<path
							d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
							fill="white"
						/>
						<path
							d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
							fill="white"
						/>
						<path
							d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
							fill="white"
						/>
						<path
							d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
							fill="white"
						/>
					</svg>
				</div>
			</div>
		</div>

		<BaseButton
			@click.stop="handleClick(item)"
			class="product-card__submit _btn-bordered"
			:class="{ 'product-card__submit_market': isMarket }"
		>
			{{ $t(`Add`) }}
		</BaseButton>
	</div>
</template>

<script>
import BaseButton, { ButtonThemes } from '@/components/base/BaseButton.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'ProductCard',
	components: { BaseButton },
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		item: {
			type: Object,
			required: true,
		},
		currencySymbol: {
			type: String,
			required: true,
		},
		sale: {
			type: Boolean,
		},
		lastSale: {
			type: Boolean,
		},
		isListingPage: {
			type: Boolean,
		},
		chosenItem: {
			type: String,
			required: true,
		},
		isMarket: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			imgDomain: '',
			isHovered: false,
			ButtonThemes,
		};
	},
	mounted() {
		this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
	},
	computed: {
		...mapGetters('cart', ['cartContents']),
		...mapGetters('app', ['currency']),
		hasDiscount() {
			const oldPrice = Number(this.item.old_price || 0);
			const basePrice = Number(this.item.price || 0);
			return oldPrice > basePrice;
		},
	},
	methods: {
		handleClick() {
			this.addToCart(this.item);
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		getTitle(item) {
			return item.title || item.name;
		},
		getBasePrice(item) {
			return item.price.toFixed(2);
		},
		getOldPrice(item) {
			return item.old_price.toFixed(2);
		},
		getImageUrl(item) {
			return item.item_type === 'pack'
				? item.img_url || item.image_url
				: `${this.imgDomain}${item.img_url}`;
		},
		addToCart(item) {
			if (this.isAuth) {
				const itemAlreadyInCart = this.cartContents.some(
					(cartItem) => cartItem.item_id === item.id
				);

				if (itemAlreadyInCart) {
					this.$toast.info(this.$t('This item is already in your cart.'));
					return;
				}

				this.$emit('addToCart', item);
			} else {
				this.$router.push('/signin');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.product-card {
	cursor: pointer;
	background-color: var(--bg-fourth-color);
	border-radius: var(--border-radius-primary);
	position: relative;
	display: flex;
	flex-direction: column;
	@include adaptiveValue('padding', 30, 10, 1470, 992, 1);
	padding-top: 0px;
	overflow: hidden;
	height: 100%;
	&_market {
		@media (max-width: 519.98px) {
			border-top-right-radius: 0px;
		}
	}
	&__discount-badge {
	}
	&__added-inscription {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-color: var(--bg-fifth-color);
		padding: 10px;
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
		z-index: var(--third-z-index);
		text-transform: uppercase;
		font-weight: 700;
	}
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		right: -7%;
		pointer-events: none;
		z-index: -1;
		&_market {
			@media (max-width: 519.98px) {
				top: -5%;
				right: -10%;
			}
		}
	}
	&__top {
		flex: 1 1 auto;
		&:not(:last-child) {
			margin-bottom: 10px;
		}
	}
	&__image {
		max-width: 270px;
		width: 100%;
		margin-left: auto;
		margin-right: auto;
		padding-bottom: 59%;
		&:not(:last-child) {
			margin-bottom: 10px;
		}
		&_market {
			@media (max-width: $md3) {
				padding-bottom: 67%;
			}
			@media (max-width: 519.98px) {
				padding-bottom: 75%;
			}
		}
	}
	&__title {
		&_market {
			font-weight: 700;
			@include adaptiveValue('font-size', 24, 14);
			@include adaptiveValue('line-height', 32, 18);
			@media (max-width: 519.98px) {
				font-weight: 400;
			}
		}
	}
	&__price {
		display: flex;
		justify-content: space-between;
		gap: 20px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 10);
		}
		&_market {
			@media (max-width: 519.98px) {
				display: block;
				.product-card__old {
					position: absolute;
					top: 0px;
					right: 0px;
					z-index: var(--base-z-index);
					background-color: var(--secondary-color);
					padding: 0px 5px 0px 15px;
					border-bottom-left-radius: var(--border-radius-primary);
					&-number {
						font-size: 14px;
						color: var(--bg-primary-color);
					}
					&-icon {
						flex: 0 0 14px;
						height: 14px;
					}
				}
				.product-card__new {
					padding: 4px 10px;
					border-radius: 0px;
					width: auto;
					margin-left: -10px;
				}
			}
			@media (max-width: $md5) {
				&:not(:last-child) {
					margin-bottom: 0px;
				}
			}
		}
	}
	&__old {
		align-self: center;
		display: flex;
		align-items: center;
		gap: 6px;
		&-number {
			color: var(--secondary-color);
			text-decoration: line-through;
		}
		&-icon {
			flex: 0 0 16px;
			height: 16px;
		}
	}
	&__new {
		background-color: var(--hint-color);
		border-top-left-radius: var(--border-radius-primary);
		border-bottom-left-radius: var(--border-radius-primary);
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 8px 15px;
		width: fit-content;
		margin-left: auto;
		@include adaptiveValue('margin-right', -30, -10, 1470, 992, 1);
		&-number {
		}
		&-icon {
			@include adaptiveValue('min-width', 24, 18);
			@include adaptiveValue('height', 24, 18);
		}
	}
	&__submit {
		width: 100%;
		min-height: 34px;
		&_market {
			@media (max-width: $md5) {
				border-top-left-radius: 0px;
				border-top-right-radius: 0px;
				padding: 5px 10px;
				width: auto;
				margin-left: -10px;
				margin-right: -10px;
			}
		}
	}
}
</style>
